module.exports = __webpack_public_path__ + "img/ins_step3.eb10ec44.svg";